import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { ensureLocalStateSchema } from '@/utils/localStateStore';

if (import.meta.env.PROD && import.meta.env.VITE_WEB_PLAYER_DEBUG !== 'true') {
  const noop = () => {};
  console.log = noop;
  console.info = noop;
  console.debug = noop;
  console.warn = noop;
}

ensureLocalStateSchema();

// PWA için minimal service worker kaydet (sadece install butonu için)
if ('serviceWorker' in navigator) {
  // Önce eski service worker'ı temizle
  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(registration => registration.unregister());
  });

  // Yeni service worker'ı kaydet
  navigator.serviceWorker.register('/sw.js')
    .then(() => {}) // Silent registration
    .catch(() => {}); // Silent error handling
}

createRoot(document.getElementById('root')!).render(<App />);
